import React from "react";
import logo from "../assets/images/logo.svg";
const Header = () => {
  return (
    <>
      <header id="header">
        <div className="d-flex align-items-center">
          {/* <a href="#" className="logo me-auto"> */}
          <img src={logo} alt="" className="img-fluid" />
          {/* </a> */}
        </div>
      </header>
    </>
  );
};

export default Header;
